import { config } from '../lib/config'
import { createOAuthClient } from './oauth-client'

/**
 * Scopes: read the user's own playlists (dev-mode apps may only read playlists
 * the user owns or collaborates on) and drive playback through Connect.
 */
export const SPOTIFY_SCOPES = [
  'playlist-read-private',
  'playlist-read-collaborative',
  'user-read-private',
  'user-read-playback-state',
  'user-modify-playback-state',
  'streaming',
] as const

export const spotifyAuthClient = createOAuthClient({
  authorizeEndpoint: 'https://accounts.spotify.com/authorize',
  tokenEndpoint: 'https://accounts.spotify.com/api/token',
  clientId: config.spotifyClientId,
  redirectUri: config.spotifyRedirectUri,
  scopes: SPOTIFY_SCOPES,
  storageNamespace: 'songster.spotify',
})
